import { userInfoSync } from 'hub-http/userInfo';
export const Gates = {};
export const isUngated = gateName => {
  try {
    const auth = userInfoSync();
    return auth.gates.includes(gateName);
  } catch (e) {
    return false;
  }
};
export const hasScopes = (...scopes) => {
  try {
    const auth = userInfoSync();
    return scopes.every(scope => auth.user.scopes.includes(scope));
  } catch (e) {
    return false;
  }
};
export const hasMarketingVideoScope = () => hasScopes('marketing-video');